// src/App.js
import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useParams } from 'react-router-dom';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Crm from './pages/Crm';
import AllClients from './pages/AllClients';
import Profile from './pages/Profile';
import Tasks from './pages/Tasks';
import Thoughts from './pages/Thoughts';
import DesignSystems from './pages/DesignSystems';
import Stylesheet from './pages/Stylesheet';
import BidPage from './pages/BidPage';
import IIQDesignSystem from './pages/IIQDesignSystem';
import LocaliteDesignSystem from './pages/LocaliteDesignSystem';
import './styles/App.css';

// Legacy redirects
const LegacyDashboardRedirect = () => <Navigate to="/dashboard" replace />;
const LegacyAllClientsRedirect = () => <Navigate to="/dashboard/all" replace />;
const LegacyClientRedirect = () => {
  const { clientId } = useParams();
  return <Navigate to={`/dashboard/${clientId}`} replace />;
};
const LegacyDesignSystemRedirect = () => <Navigate to="/ds/handyco" replace />;
const LegacyIIQRedirect = () => <Navigate to="/ds/iiq" replace />;

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} />

        {/* Dashboard pages */}
        <Route path="/dashboard" element={<Crm />} />
        <Route path="/dashboard/all" element={<AllClients />} />
        <Route path="/dashboard/profile" element={<Profile />} />
        <Route path="/dashboard/tasks" element={<Tasks />} />
        <Route path="/dashboard/thoughts" element={<Thoughts />} />
        <Route path="/dashboard/:clientId" element={<Crm />} />

        {/* Design systems — /ds/ listing is auth-locked, sub-pages are public */}
        <Route path="/ds" element={<DesignSystems />} />
        <Route path="/ds/handyco" element={<Stylesheet />} />
        <Route path="/ds/iiq" element={<IIQDesignSystem />} />
        <Route path="/ds/localite" element={<LocaliteDesignSystem />} />

        {/* Legacy redirects */}
        <Route path="/crm" element={<LegacyDashboardRedirect />} />
        <Route path="/crm/all" element={<LegacyAllClientsRedirect />} />
        <Route path="/crm/:clientId" element={<LegacyClientRedirect />} />
        <Route path="/designsystem" element={<LegacyDesignSystemRedirect />} />
        <Route path="/iiq-designsys" element={<LegacyIIQRedirect />} />

        <Route path="/proposal/:clientName" element={<BidPage />} />

        <Route
          path="*"
          element={
            <div style={{
              textAlign: 'center',
              padding: '50px',
              backgroundColor: '#19231F',
              minHeight: '100vh',
              color: '#9CACA6',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <h2 style={{ fontSize: '48px', marginBottom: '20px', fontFamily: 'Lexend, sans-serif', fontWeight: 800 }}>404</h2>
              <p style={{ fontSize: '20px', fontFamily: 'Book Antiqua, serif', fontStyle: 'italic' }}>
                The page you're looking for does not exist.
              </p>
            </div>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
